import { atom } from 'recoil';

export const scansAtom = atom({
  key: 'scansAtom', 
  default: {
    loading: false,
    item: null,
    items: [],
    error: null
  },
});